import { parse } from 'date-fns';
import { z } from 'zod';

export const companyDocumentRequestSchema = z.object({
  status: z.object({
    value: z.string(),
    label: z.string(),
  }),
  document: z.object({
    value: z.string(),
    label: z.string(),
  }),
  reason: z.object({
    value: z.string(),
    label: z.string(),
  }),
  reasonFields: z.record(z.string()),
  dateForApproval: z
    .string()
    .transform((v) => parse(v, 'yyyy-MM-dd', new Date()).toISOString()),
  observation: z.string().min(1, { message: 'Obrigatório' }),
});

export type CompanyDocumentRequestSchema = z.infer<
  typeof companyDocumentRequestSchema
>;

export type CompanyDocumentRequestDefaultValue =
  CompanyDocumentRequestSchema & {
    hasUploadedFile?: boolean;
    justification?: string | null;
  };
